import { useQuery } from "@tanstack/react-query"
import { Study } from "../types/types"
import { apiFetch } from "../utils/api"

const fecthStudy = async (hash: string): Promise<Study> =>
  apiFetch<Study>("/filter/studies/" + hash, {})

export const useStudyQuery = <TData = Study>(
  hash: string | undefined | null,
  select?: (data: Study) => TData
) => {
  return useQuery({
    queryKey: ["study", hash],
    queryFn: () => fecthStudy(hash?.toString() ?? ""),
    enabled: !!hash,
    select
  })
}
